// import { jwtDecode } from "jwt-decode";
// import api from './api';
// import { Preferences } from '@capacitor/preferences';


// // Description: Login user functionality
// // Endpoint: POST /api/auth/login
// // Request: { email: string, password: string }
// // Response: { accessToken: string, refreshToken: string }
// export const login = async (email: string, password: string) => {
//   try {
//     console.log("auth.ts: Making login request for:", email);
//     const formData = new FormData();
//     formData.append('username', email);
//     formData.append('password', password);
//     const response = await api.post('/api/auth/login', formData);
//     console.log("auth.ts: Login response data:", response.data);
//     const user = jwtDecode(response?.data?.access_token);

//     await Preferences.set({ key: "level", value: user?.association?.level?.toString() });
//     await Preferences.set({ key: 'employee_id', value: user?.id });
//     await Preferences.set({ key: "branchID", value: user?.association?.branchID });
//     await Preferences.set({ key: "headOfficeID", value: user?.association?.headOfficeID });
//     await Preferences.set({ key: "masterID", value: user?.association?.masterID });

//     console.log("masterID", await Preferences.get({ key: "masterID" }));
//     console.log("headOfficeId", await Preferences.get({ key: "headOfficeID" }));
//     await Preferences.set({ key: "workfromhome", value: user?.workfromhome });
//     await Preferences.set({ key: "workingHoursStart1", value: user?.wifi_ssid[1]?.working_hours_start });
//     await Preferences.set({ key: "workingHoursEnd1", value: user?.wifi_ssid[1]?.working_hours_end });
//     await Preferences.set({ key: "maxDistance1", value: user?.wifi_ssid[1]?.radius_meters?.toString() });
//     await Preferences.set({ key: "officeLon1", value: user?.wifi_ssid[1]?.longitude });
//     await Preferences.set({ key: "officeLat1", value: user?.wifi_ssid[1]?.lattitude });
//     await Preferences.set({ key: "workingHoursStart2", value: user?.wifi_ssid[2]?.working_hours_start });
//     await Preferences.set({ key: "workingHoursEnd2", value: user?.wifi_ssid[2]?.working_hours_end });
//     await Preferences.set({ key: "maxDistance2", value: user?.wifi_ssid[2]?.radius_meters?.toString() });
//     await Preferences.set({ key: "officeLon2", value: user?.wifi_ssid[2]?.longitude });
//     await Preferences.set({ key: "officeLat2", value: user?.wifi_ssid[2]?.lattitude });
//     await Preferences.set({ key: "workingHoursStart3", value: user?.wifi_ssid[3]?.working_hours_start });
//     await Preferences.set({ key: "workingHoursEnd3", value: user?.wifi_ssid[3]?.working_hours_end });
//     await Preferences.set({ key: "maxDistance3", value: user?.wifi_ssid[3]?.radius_meters?.toString() });
//     await Preferences.set({ key: "officeLon3", value: user?.wifi_ssid[3]?.longitude });
//     await Preferences.set({ key: "officeLat3", value: user?.wifi_ssid[3]?.lattitude });

//     return response.data;
//   } catch (error: any) {
//     console.error('auth.ts: Login error:', error);
//     console.error('auth.ts: Error response:', error?.response?.data);
//     throw new Error(error?.response?.data?.message || error.message);
//   }
// };

// // Description: Register user functionality
// // Endpoint: POST /api/auth/register
// // Request: { email: string, password: string }
// // Response: { email: string }

// export const register = async (email: string, password: string, role: string) => {
//   try {
//     console.log("auth.ts: Making registration request for:", email, "with role:", role);
//     const response = await api.post('/api/auth/register', {
//       email,
//       password,
//       role,
//     });
//     console.log("auth.ts: Registration response data:", response.data);
//     return response.data;
//   } catch (error: any) {
//     console.error('auth.ts: Registration error:', error);
//     console.error('auth.ts: Error response:', error?.response?.data);
//     throw new Error(error?.response?.data?.message || error.message);
//   }
// };


// // Description: Logout
// // Endpoint: POST /api/auth/logout
// // Request: {}
// // Response: { success: boolean, message: string }
// export const logout = async () => {
//   try {
//     console.log("auth.ts: Making logout request");
//     return await api.post('/api/auth/logout');
//   } catch (error: any) {
//     console.error('auth.ts: Logout error:', error);
//     throw new Error(error?.response?.data?.message || error.message);
//   }
// }; 




import { jwtDecode } from "jwt-decode";
import api from './api';
import { Preferences } from '@capacitor/preferences';
import { Capacitor } from '@capacitor/core';

// Per-tab session storage. On the web each browser tab keeps its OWN session in
// sessionStorage, so a user can be signed into a different organization per tab
// and logging out in one tab doesn't affect the others. Native keeps using
// Capacitor Preferences (single-session; no tabs).
const _isNative = () => Capacitor.isNativePlatform();

const storeSession = async (key: string, value: any): Promise<void> => {
  const v = value == null ? "" : String(value);
  if (_isNative()) {
    await Preferences.set({ key, value: v });
  } else {
    try { sessionStorage.setItem(key, v); } catch { /* non-fatal */ }
  }
};

const readSession = async (key: string): Promise<string | null> => {
  if (_isNative()) {
    const { value } = await Preferences.get({ key });
    return value;
  }
  try { return sessionStorage.getItem(key); } catch { return null; }
};

const clearSession = async (key: string): Promise<void> => {
  if (_isNative()) {
    await Preferences.remove({ key });
  } else {
    try {
      sessionStorage.removeItem(key);
      localStorage.removeItem(key); // drop any legacy shared copy
    } catch { /* non-fatal */ }
  }
};

// Description: Get organizations by email
// Endpoint: POST /api/auth/get-organizations
// Request: { email: string }
// Response: { success: boolean, organizations: Array<{ head_office_id: string, company_name: string, organization: string }> }
export const getOrganizations = async (email: string) => {
  try {
    console.log("auth.ts: Getting organizations for email:", email);
    const response = await api.post('/api/auth/get-organizations', { email });
    console.log("auth.ts: Organizations response:", response.data);
    return response.data;
  } catch (error: any) {
    console.error('auth.ts: Get organizations error:', error);
    console.error('auth.ts: Error response:', error?.response?.data);
    throw new Error(error?.response?.data?.detail || error.message);
  }
};

// Everything a completed login has to put in per-tab storage, shared by the
// password flow and the Google flow — they differ only in how the identity is
// proved, never in what a signed-in tab needs to hold.
const persistLoginSession = async (access_token: string, email: string) => {
  // Decode the JWT token to get user information
  const user: any = jwtDecode(access_token);
  console.log("auth.ts: Decoded user from token:", user);

  // Store token (per-tab on web — see storeSession)
  await storeSession('access_token', access_token);

  // Store user information from decoded token
  await storeSession("level", user?.association?.level?.toString());
  await storeSession('employee_id', user?.id);
  await storeSession("branchID", user?.association?.branchID);
  await storeSession("headOfficeID", user?.association?.headOfficeID);
  await storeSession("masterID", user?.association?.masterID);
  await storeSession("email", email);
  await storeSession("company_name", user?.company_name);

  // Store work location settings if available
  await storeSession("workfromhome", user?.workfromhome?.toString());

  // Store WiFi/Office location settings (supports up to 3 locations)
  if (user?.wifi_ssid) {
    for (let i = 1; i <= 3; i++) {
      if (user.wifi_ssid[i]) {
        await storeSession(`workingHoursStart${i}`, user.wifi_ssid[i]?.working_hours_start);
        await storeSession(`workingHoursEnd${i}`, user.wifi_ssid[i]?.working_hours_end);
        await storeSession(`maxDistance${i}`, user.wifi_ssid[i]?.radius_meters?.toString());
        await storeSession(`officeLon${i}`, user.wifi_ssid[i]?.longitude);
        await storeSession(`officeLat${i}`, user.wifi_ssid[i]?.lattitude);
      }
    }
  }
};

// Description: Login with organization selection
// Endpoint: POST /api/auth/login-select
// Request: { email: string, password: string, head_office_id: string }
// Response: { access_token: string, token_type: string }
export const loginSelect = async (email: string, password: string, head_office_id: string) => {
  try {
    console.log("auth.ts: Making login-select request for:", email, "with head_office_id:", head_office_id);
    const response = await api.post('/api/auth/login-select', {
      email,
      password,
      head_office_id
    });
    console.log("auth.ts: Login-select response data:", response.data);

    const { access_token } = response.data;

    if (access_token) {
      await persistLoginSession(access_token, email);
    }

    return response.data;
  } catch (error: any) {
    console.error('auth.ts: Login-select error:', error);
    console.error('auth.ts: Error response:', error?.response?.data);
    throw new Error(error?.response?.data?.detail || error.message);
  }
};

// Description: Exchange a Google ID token for this email's workspace list.
// Does not sign anyone in — one email can belong to several workspaces, so the
// caller still has to choose one and come back with the ticket.
// Endpoint: POST /api/auth/google
// Request: { credential: string }
// Response: { success: boolean, email: string, ticket: string, organizations: Array<{ head_office_id, company_name, organization }> }
export const googleAuth = async (credential: string) => {
  try {
    const response = await api.post('/api/auth/google', { credential });
    console.log("auth.ts: Google auth response:", response.data);
    return response.data;
  } catch (error: any) {
    console.error('auth.ts: Google auth error:', error?.response?.data || error);
    throw new Error(error?.response?.data?.detail || error.message);
  }
};

// Description: Complete a Google sign-in for the chosen workspace.
// Endpoint: POST /api/auth/google/login-select
// Request: { ticket: string, head_office_id: string }
// Response: { access_token: string, refresh_token: string, token_type: string }
export const googleLoginSelect = async (ticket: string, head_office_id: string, email: string) => {
  try {
    const response = await api.post('/api/auth/google/login-select', {
      ticket,
      head_office_id,
    });

    const { access_token } = response.data;

    if (access_token) {
      await persistLoginSession(access_token, email);
    }

    return response.data;
  } catch (error: any) {
    console.error('auth.ts: Google login-select error:', error?.response?.data || error);
    throw new Error(error?.response?.data?.detail || error.message);
  }
};

// Description: Legacy login (kept for backward compatibility)
// Endpoint: POST /api/auth/login
// Request: { email: string, password: string }
// Response: { accessToken: string, refreshToken: string }
// export const login = async (email: string, password: string) => {
//   try {
//     console.log("auth.ts: Making login request for:", email);
//     const formData = new FormData();
//     formData.append('username', email);
//     formData.append('password', password);
//     const response = await api.post('/api/auth/login', formData);
//     console.log("auth.ts: Login response data:", response.data);
//     const user = jwtDecode(response?.data?.access_token);

//     await Preferences.set({ key: "level", value: user?.association?.level?.toString() });
//     await Preferences.set({ key: 'employee_id', value: user?.id });
//     await Preferences.set({ key: "branchID", value: user?.association?.branchID });
//     await Preferences.set({ key: "headOfficeID", value: user?.association?.headOfficeID });
//     await Preferences.set({ key: "masterID", value: user?.association?.masterID });

//     console.log("masterID", await Preferences.get({ key: "masterID" }));
//     console.log("headOfficeId", await Preferences.get({ key: "headOfficeID" }));
//     await Preferences.set({ key: "workfromhome", value: user?.workfromhome });
//     await Preferences.set({ key: "workingHoursStart1", value: user?.wifi_ssid[1]?.working_hours_start });
//     await Preferences.set({ key: "workingHoursEnd1", value: user?.wifi_ssid[1]?.working_hours_end });
//     await Preferences.set({ key: "maxDistance1", value: user?.wifi_ssid[1]?.radius_meters?.toString() });
//     await Preferences.set({ key: "officeLon1", value: user?.wifi_ssid[1]?.longitude });
//     await Preferences.set({ key: "officeLat1", value: user?.wifi_ssid[1]?.lattitude });
//     await Preferences.set({ key: "workingHoursStart2", value: user?.wifi_ssid[2]?.working_hours_start });
//     await Preferences.set({ key: "workingHoursEnd2", value: user?.wifi_ssid[2]?.working_hours_end });
//     await Preferences.set({ key: "maxDistance2", value: user?.wifi_ssid[2]?.radius_meters?.toString() });
//     await Preferences.set({ key: "officeLon2", value: user?.wifi_ssid[2]?.longitude });
//     await Preferences.set({ key: "officeLat2", value: user?.wifi_ssid[2]?.lattitude });
//     await Preferences.set({ key: "workingHoursStart3", value: user?.wifi_ssid[3]?.working_hours_start });
//     await Preferences.set({ key: "workingHoursEnd3", value: user?.wifi_ssid[3]?.working_hours_end });
//     await Preferences.set({ key: "maxDistance3", value: user?.wifi_ssid[3]?.radius_meters?.toString() });
//     await Preferences.set({ key: "officeLon3", value: user?.wifi_ssid[3]?.longitude });
//     await Preferences.set({ key: "officeLat3", value: user?.wifi_ssid[3]?.lattitude });

//     return response.data;
//   } catch (error: any) {
//     console.error('auth.ts: Login error:', error);
//     console.error('auth.ts: Error response:', error?.response?.data);
//     throw new Error(error?.response?.data?.detail || error.message);
//   }
// };

// Description: Who is this Google account, for the signup form. Unlike
// googleAuth() this does not refuse an email with no account — that is the
// point of a signup. The ticket it returns stands in for the password.
// Endpoint: POST /api/auth/google/signup
// Request: { credential: string }
// Response: { email, first_name, last_name, ticket, workspace_exists }
export const googleSignupIdentity = async (credential: string) => {
  try {
    const response = await api.post('/api/auth/google/signup', { credential });
    return response.data;
  } catch (error: any) {
    console.error('auth.ts: Google signup error:', error?.response?.data || error);
    throw new Error(error?.response?.data?.detail || error.message);
  }
};

// Description: Register user functionality
// Endpoint: POST /api/auth/register
// Request: { email, password, role, first_name, last_name, mobile, company_name? }
// Response: { email: string }
export const register = async (
  email: string,
  password: string,
  role: string,
  first_name: string,
  last_name: string,
  mobile: string,
  company_name?: string,
  plan: "starter" | "professional" | "enterprise" = "starter",
  google_ticket?: string,
) => {
  try {
    console.log("auth.ts: Making registration request for:", email, "with role:", role);
    const payload: Record<string, any> = {
      email,
      password,
      role,
      first_name,
      last_name,
      mobile,
      plan,
    };
    // A Google signup has no password: the ticket proves the address instead.
    if (google_ticket) {
      payload.google_ticket = google_ticket;
      delete payload.password;
    }
    const trimmedCompany = (company_name || "").trim();
    if (trimmedCompany) payload.company_name = trimmedCompany;

    const response = await api.post('/api/auth/register', payload);
    console.log("auth.ts: Registration response data:", response.data);
    return response.data;
  } catch (error: any) {
    console.error('auth.ts: Registration error:', error);
    console.error('auth.ts: Error response:', error?.response?.data);
    throw new Error(error?.response?.data?.detail || error.message);
  }
};

// Description: Logout
// Endpoint: POST /api/auth/logout
// Request: {}
// Response: { success: boolean, message: string }
export const logout = async () => {
  console.log("auth.ts: Making logout request");

  // Release this device's session slot FIRST — the endpoint needs the bearer
  // token to know whose slot to free, and the clearSession calls below take
  // that token away. Never let this fail the logout: a user who cannot reach
  // the API must still be able to sign out locally. The slot they leave behind
  // is reclaimed by their next login on this platform.
  try {
    await api.post('/api/auth/logout');
  } catch (error) {
    console.warn('auth.ts: logout slot release failed (signing out anyway)', error);
  }

  // Clear all stored session values (this tab only on web)
  await clearSession('access_token');
  await clearSession('employee_id');
  await clearSession('level');
  await clearSession('branchID');
  await clearSession('headOfficeID');
  await clearSession('masterID');
  await clearSession('email');
  await clearSession('company_name');
  await clearSession('workfromhome');

  // Clear location settings
  for (let i = 1; i <= 3; i++) {
    await clearSession(`workingHoursStart${i}`);
    await clearSession(`workingHoursEnd${i}`);
    await clearSession(`maxDistance${i}`);
    await clearSession(`officeLon${i}`);
    await clearSession(`officeLat${i}`);
  }
};

// Description: Check if user is authenticated
// Endpoint: N/A
// Request: N/A
// Response: boolean
export const isAuthenticated = async (): Promise<boolean> => {
  try {
    const tokenValue = await readSession('access_token');
    if (!tokenValue) return false;

    // Check if token is expired
    const decoded: any = jwtDecode(tokenValue);
    const currentTime = Date.now() / 1000;
    
    if (decoded.exp && decoded.exp < currentTime) {
      // Token expired
      await logout();
      return false;
    }
    
    return true;
  } catch (error) {
    console.error('auth.ts: Auth check error:', error);
    return false;
  }
};

// Description: Get current user
// Endpoint: N/A
// Request: N/A
// Response: User object or null
export const getCurrentUser = async () => {
  try {
    const tokenValue = await readSession('access_token');
    if (!tokenValue) return null;

    const user: any = jwtDecode(tokenValue);
    return user;
  } catch (error) {
    console.error('auth.ts: Get current user error:', error);
    return null;
  }
};

// Description: Shut an account's sign-in by hand, and the password reset with
// it. Not the same thing as the three-wrong-passwords lock: that one protects
// an account from a guesser, so 'Forgot password' is a fair way back in. This
// one takes the account away from the person who reads that mailbox, so the
// reset is refused too and only `unlockLogin` reopens it. Live sessions end
// with it — the server drops every slot and pushes a sign-out.
// Endpoint: POST /api/auth/lock-login
// Request: { email: string }
// Response: { success: boolean, email: string, locked: true, was_locked: boolean, message: string }
export const lockLogin = async (email: string) => {
  try {
    const response = await api.post('/api/auth/lock-login', { email });
    return response.data as {
      success: boolean;
      email: string;
      locked: boolean;
      was_locked: boolean;
      message: string;
    };
  } catch (error: any) {
    throw new Error(error?.response?.data?.detail || error.message);
  }
};

// Description: Let an account back in — after three wrong passwords shut it,
// or after an admin did.
// For a counter lock this is one of two doors; the other is the emailed-OTP
// password reset, which needs no admin at all. For an admin lock it is the
// only one. It does NOT change the password — if a
// forgotten password is what locked them out, unlocking just hands them three
// more attempts at the same wrong guess, which is why the server says so in
// `message` and the caller shows it.
// Endpoint: POST /api/auth/unlock-login
// Request: { email: string }
// Response: { success: boolean, email: string, was_locked: boolean, message: string }
export const unlockLogin = async (email: string) => {
  try {
    const response = await api.post('/api/auth/unlock-login', { email });
    return response.data as {
      success: boolean;
      email: string;
      was_locked: boolean;
      message: string;
    };
  } catch (error: any) {
    throw new Error(error?.response?.data?.detail || error.message);
  }
};
